module.exports = __webpack_public_path__ + "static/dt-6b03382a174e2871afa0374b7d6282b4.png";